var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"init-wrapper"},[_c('div',{staticClass:"init"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.logoSrc}})]),_c('clip-loader',{attrs:{"color":_vm.loaderColor,"size":"32px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }